import { defineMessages } from 'react-intl';

export default defineMessages({
  requiredField: {
    id: 'required.field',
  },
  errorDate: {
    id: 'Input.Error.Date',
  },
  errorAmount: {
    id: 'Input.Error.amount',
  },
  errorPhone: {
    id: 'sign_auth.phone_valid_error',
  },
  errorEmail: {
    id: 'signup_personal_info.email.error',
  },
  errorDateAnterior: {
    id: 'Input.Error.Date.anterior',
  },
});
